module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('header', {
    staticClass: "site_header"
  }, [(_vm.props) ? _c('div', {
    staticClass: "tophead"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "h_address"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address)
    }
  })])]), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "h_phone"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone)
    }
  }), _c('router-link', {
    attrs: {
      "to": "/",
      "target": "_blank",
      "aria-label": "Home"
    }
  })], 1)]), _c('div', {
    staticClass: "middle"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "aria-label": "Home"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.logo.url,
      "alt": "logo"
    }
  })])], 1)]) : _vm._e(), _c('div', {
    staticClass: "homeslider"
  }, [_c('div', {
    staticClass: "innerslide"
  }, _vm._l((_vm.props.acf.actorslider), function(actorslider) {
    return (_vm.props) ? _c('div', {
      staticClass: "header-slider-inner"
    }, [_c('img', {
      staticClass: "slimg",
      attrs: {
        "src": actorslider.url,
        "alt": "slide"
      }
    })]) : _vm._e()
  })), _c('div', {
    staticClass: "home_social"
  }, [_c('router-link', {
    staticClass: "blogger_link",
    attrs: {
      "to": "/",
      "target": "_blank",
      "aria-label": "Home"
    }
  }), _c('a', {
    staticClass: "fb_link",
    attrs: {
      "href": "https://www.facebook.com/Beaumontortho",
      "target": "_blank",
      "aria-label": "facebook"
    }
  })], 1)]), _c('div', {
    staticClass: "test"
  }, [_vm._m(0), _c('Navigation')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "togglebt",
    attrs: {
      "onclick": "menuToggle()"
    }
  }, [_c('span'), _c('span'), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178146fc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 573
// module chunks = 1